export const notInArvoreKey = 'not_in_arvore'
